<template>
    <DModal
        is-big
        :show="showModal"
        :title="__('contracts.fulfillment.herold_at.modal_zip_code_title')"
        @close="closeModal"
    >
        <div>
            <DRow class="pr-1 pb-2 row-width">
                <DCol
                    class="pt-1"
                    sm="3"
                >
                    <DInput
                        id="herold_zip_search_input"
                        v-model="searchFilters.zipName"
                        type="number"
                        :label="__('contracts.fulfillment.herold_at.filters.postalcode')"
                        :invalid-feedback="errors.zipName"
                    />
                </DCol>
                <DCol
                    class="pt-1"
                    sm="3"
                >
                    <DInput
                        id="herold_city_search_input"
                        v-model="searchFilters.cityName"
                        :label="__('contracts.fulfillment.herold_at.filters.city')"
                        :invalid-feedback="errors.cityName"
                    />
                </DCol>
                <DCol
                    class="pt-1"
                    sm="3"
                >
                    <DInput
                        id="herold_district_search_input"
                        v-model="searchFilters.districtName"
                        :label="__('contracts.fulfillment.herold_at.filters.district')"
                        :invalid-feedback="errors.districtName"
                    />
                </DCol>
                <DCol
                    class="pt-1 d-flex justify-content-around"
                    sm="3"
                >
                    <div class="h-100 d-flex align-items-end">
                        <DButton
                            id="herold_input_filter"
                            :label="__('contracts.fulfillment.herold_at.filters.search')"
                            color="secondary"
                            @click="getZipCodes"
                        />
                    </div>
                    <div class="h-100 d-flex align-items-end">
                        <DButton
                            id="herold_reset_filters"
                            :label="__('contracts.fulfillment.herold_at.filters.reset_filters')"
                            color="secondary"
                            @click="resetFilters"
                        />
                    </div>
                </DCol>
            </DRow>
            <DRow class="row-width">
                <DFieldLoading
                    v-if="isLoading"
                    :is-loading="isLoading"
                    is-big
                    class="my-4 d-flex justify-content-center"
                />
                <h4
                    v-if="searchParamsNotApplied"
                    class="text-center py-4"
                >
                    {{ __('contracts.fulfillment.herold_at.modal_message') }}
                </h4>
                <DTable
                    v-if="!isLoading && !searchParamsNotApplied"
                    :fields="fields"
                    :items="zipCodes"
                    :items-per-page="10"
                    pagination
                    :pagination-props="{align: 'center'}"
                >
                    <template #actions="{item}">
                        <td>
                            <DButton
                                id="select-location"
                                icon="check-circle"
                                color="success"
                                mini
                                @click="selectZipCode(item)"
                            />
                        </td>
                    </template>
                </DTable>
            </DRow>
        </div>
    </DModal>
</template>

<script setup>

import { ref } from 'vue'
import { route } from '~@/Composables/route'
import { __ } from '~@/Composables/translation'
import DFieldLoading from '~@/Components/Common/DFieldLoading'

defineProps({
    showModal: {
        type: Boolean,
        default: false
    }
})

const emit = defineEmits(['close-modal', 'update:modelValue'])

const fields = ref([
    { key: 'label', label: __('contracts.fulfillment.herold_at.table.zip'), _style: { width: '200px' } },
    { key: 'city', label: __('contracts.fulfillment.herold_at.table.city'), _style: { width: '500px' } },
    { key: 'district', label: __('contracts.fulfillment.herold_at.table.district'), _style: { width: '500px' } },
    { key: 'actions', label: '', _classes: 'text-right', filter: false }
])

const zipCodes = ref([])
const isLoading = ref(false)
const searchFilters = ref({
    zipName: null,
    cityName: null,
    districtName: null
})
const errors = ref({})

const searchParamsNotApplied = ref(true)

async function getZipCodes () {
    isLoading.value = true
    searchParamsNotApplied.value = false
    // Filter empty search parameters
    const requestData = Object.keys(searchFilters.value).reduce(
        (res, key) => {
            const value = searchFilters.value[key]
            if (value !== '' && value !== null) {
                res[key] = value
            }
            return res
        }, {})
    await window.axios.get(route('customers.herold_at.zip-codes', { _query: requestData }))
        .then((response) => {
            zipCodes.value = response.data.zipCodes
            errors.value = {}
        })
        .catch((error) => {
            if (error.response.data.errors !== undefined) {
                errors.value = error.response.data.errors
            }
            searchParamsNotApplied.value = true
        })
    isLoading.value = false
}

const closeModal = () => {
    emit('close-modal')
}

const selectZipCode = (item) => {
    emit('update:modelValue', { value: item.value, display_value: item.label + ' - ' + item.city + ' - ' + item.district })
}

const resetFilters = () => {
    searchFilters.value.zipName = null
    searchFilters.value.cityName = null
    searchParamsNotApplied.value = true
    errors.value = {}
}
</script>

<style scoped>
.row-width {
    margin: 0;
    width: 100%;
}
</style>
